export const AUCKLAND_TIME_ZONE = 'Pacific/Auckland';

function validDate(value: Date | string | number): Date | null {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function aucklandDateKey(value: Date | string | number = new Date()): string {
  const date = validDate(value);
  if (!date) return '';
  const parts = new Intl.DateTimeFormat('en-NZ', {
    timeZone: AUCKLAND_TIME_ZONE,
    year: 'numeric', month: '2-digit', day: '2-digit'
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find(item => item.type === type)?.value || '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function aucklandHour(value: Date | string | number = new Date()): number {
  const date = validDate(value);
  if (!date) return 0;
  const hour = new Intl.DateTimeFormat('en-NZ', {
    timeZone: AUCKLAND_TIME_ZONE,
    hour: '2-digit',
    hourCycle: 'h23'
  }).formatToParts(date).find(item => item.type === 'hour')?.value;
  return Number(hour || 0);
}

export function aucklandClockParts(value: Date | string | number): [string, string] {
  const date = validDate(value);
  if (!date) return ['--', ''];
  const parts = new Intl.DateTimeFormat('en-NZ', {
    timeZone: AUCKLAND_TIME_ZONE,
    hour: 'numeric', minute: '2-digit', hour12: true
  }).formatToParts(date);
  const hour = parts.find(item => item.type === 'hour')?.value || '--';
  const minute = parts.find(item => item.type === 'minute')?.value || '00';
  const dayPeriod = (parts.find(item => item.type === 'dayPeriod')?.value || '').toUpperCase();
  return [`${hour}:${minute}`, dayPeriod];
}

export function addDateKeyDays(dateKey: string, days: number): string {
  const [year, month, day] = dateKey.split('-').map(Number);
  if (!year || !month || !day) return dateKey;
  const date = new Date(Date.UTC(year, month - 1, day + days, 12));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
}

export function dateKeyLabel(dateKey: string, options: Intl.DateTimeFormatOptions): string {
  const [year, month, day] = dateKey.split('-').map(Number);
  if (!year || !month || !day) return dateKey;
  return new Date(Date.UTC(year, month - 1, day, 12)).toLocaleDateString('en-NZ', { ...options, timeZone: 'UTC' });
}

export function dateKeyEpoch(dateKey: string): number | null {
  const [year, month, day] = dateKey.split('-').map(Number);
  if (!year || !month || !day) return null;
  return Date.UTC(year, month - 1, day);
}
